import { css, styled } from 'styled-components';

import Link from 'components/Link';

const IconButton = styled(Link)(
  ({ theme }) => css`
    font-size: 0.875rem;
    opacity: 0.5;
    color: ${theme.colors.primaryBlack2};
    text-decoration: none;
    transition: opacity 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);

    &:hover {
      opacity: 1;
    }
  `
);

export default IconButton;
